module.exports = __webpack_public_path__ + "img/slide-8.958fb50b.png";